// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__MeB8I","ranges":"BmiRanges_ranges__2LlwB"};